import { useEffect, useState } from "react";
import "./RouteProgress.css";

export interface RouteProgressProps {
  active?: boolean;
}

/**
 * Barra fininha no topo da tela durante navegação entre rotas pesadas
 * (briefing de design, seção 5).
 */
export function RouteProgress({ active }: RouteProgressProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!active) {
      const t = setTimeout(() => setVisible(false), 200);
      return () => clearTimeout(t);
    }
    setVisible(true);
  }, [active]);

  if (!visible) return null;
  return (
    <div className="pr-route-progress" aria-hidden="true">
      <div className="pr-route-progress__bar" />
    </div>
  );
}
